// src/components/common/StatusCard.jsx
import React from 'react';

const StatusCard = ({ icon, title, value, color }) => (
  <div className={`flex items-center ${color} p-3 rounded-xl min-w-32 shadow-sm border border-gray-100`}>
    <div className="w-10 h-10 rounded-lg flex items-center justify-center mr-3">
      {icon}
    </div>
    <div>
      <p className="text-xs text-gray-600">{title}</p>
      <p className="font-semibold text-gray-800">{value}</p>
    </div>
  </div>
);

export default StatusCard;